import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';
import { MenuEnum } from './core/Enums/menuEnum';
import { Role } from './core/Enums/Role';
import { AuthenticationService } from './core/services/auth.service';
import { MENU } from './layouts/sidebar/menu';
import { MenuItem } from './layouts/sidebar/menu.model';

@Injectable({
  providedIn: 'root'
})
export class SiderbarService {
  Roles = Role;
  activeMenus: BehaviorSubject<MenuItem[]> = new BehaviorSubject<MenuItem[]>([]);
  constructor(private authService: AuthenticationService) {
    this.activeMenus.next(MENU);
    // if(localStorage.getItem('sideMenu')) this.ShowMenu(+localStorage.getItem('sideMenu'));
    // this.customizeSideMenu(MenuEnum.ControlPanel);
  }

  ShowMenu() {
    var currentUser = this.authService.currentUserValue;
    var updatedValues = this.activeMenus.value.filter(c => {
      c.isVisible = false;
      switch (c.id) {
        case 2: c.isVisible = currentUser.riskAssisment || currentUser.role == Role.SuperAdmin; //RM
          break;
        case 10: c.isVisible = currentUser.cyberAssisment || currentUser.role == Role.SuperAdmin; //CYB
          break;
        case 19: c.isVisible = currentUser.cp || currentUser.role == Role.SuperAdmin;// Setting
          this.customizeSideMenu(c.id);
          break;
        case 8: c.isVisible = currentUser.crewRS || currentUser.role == Role.SuperAdmin; //Crew

          if (!this.authService.isOfficeUser) {
            c.subItems.find(x => x.menuItem == 'ctrlPanel').isVisible = false;
            c.subItems.find(x => x.menuItem == 'crewmatrix').isVisible = false;
          } else {
            c.subItems.find(x => x.menuItem == 'ctrlPanel').isVisible = true;
            c.subItems.find(x => x.menuItem == 'crewmatrix').isVisible = true;

          }
          break;
        case 41: c.isVisible = currentUser.audit || currentUser.role == Role.SuperAdmin; //Audit
          break;
        // case 51: c.isVisible = currentUser.crewM || currentUser.role == Role.SuperAdmin; //CP
        //   break;
        case 55: c.isVisible = currentUser.dms || currentUser.role == Role.SuperAdmin;
          break;
        case 61: c.isVisible = currentUser.gapAnalysis || currentUser.role == Role.SuperAdmin;
          break;
        case 71: c.isVisible = currentUser.iaia || currentUser.role == Role.SuperAdmin;
          break;
        case 81: c.isVisible = currentUser.formMatrix || currentUser.role == Role.SuperAdmin;
          break;
        case 91: c.isVisible = currentUser.academy || currentUser.role == Role.SuperAdmin;
          break;
        // case 30: c.isVisible = currentUser.kpi || currentUser.role == Role.SuperAdmin;
        //   break;
      }
      //if (c.id == menuNumber) c.isVisible = !c.isVisible
      if (c.id == 1) c.isVisible = true;
      return true;
    });

    // if (menuNumber == MenuEnum.ControlPanel) this.customizeSideMenu(menuNumber);
    // if (c.id == MenuEnum.Crew) {
    //   var crew = this.activeMenus.value.find(x => x.id == menuNumber);
    //   if (!this.authService.isOfficeUser) {
    //     crew.subItems.find(x => x.menuItem == 'ctrlPanel').isVisible = false;
    //     crew.subItems.find(x => x.menuItem == 'crewmatrix').isVisible = false;
    //   } else {
    //     crew.subItems.find(x => x.menuItem == 'ctrlPanel').isVisible = true;
    //     crew.subItems.find(x => x.menuItem == 'crewmatrix').isVisible = true;

    //   }
    // }

    this.activeMenus.next(updatedValues);
  }

  customizeSideMenu(menuNumber: number) {
    const currentUser = this.authService.currentUserValue;
    var ctrlPanel = this.activeMenus.value.find(x => x.id == menuNumber);
    var ass = this.activeMenus.value.find(x => x.id)

    if (currentUser) {
      ctrlPanel.subItems.find(x => x.menuItem == 'users').isVisible = currentUser.users;
      ctrlPanel.subItems.find(x => x.menuItem == 'isVessel').isVisible = currentUser.isVessel;
      ctrlPanel.subItems.find(x => x.menuItem == 'sub').isVisible = currentUser.sub;
      ctrlPanel.subItems.find(x => x.menuItem == 'userLogs').isVisible = currentUser.userLogs;
      // ctrlPanel.subItems.find(x => x.menuItem == 'activities').isVisible = currentUser.activities;
      if (currentUser.role == this.Roles.SuperAdmin) {

        ctrlPanel.subItems.find(x => x.menuItem == 'sub').isVisible = false;
        ctrlPanel.subItems.find(x => x.menuItem == 'review').isVisible = true;
        ctrlPanel.subItems.find(x => x.menuItem == 'company').isVisible = true;
        ctrlPanel.subItems.find(x => x.menuItem == 'hazards-controls').isVisible = true;
        ctrlPanel.subItems.find(x => x.menuItem == 'threat-controls').isVisible = true;
        ctrlPanel.subItems.find(x => x.menuItem == 'userLogs').isVisible = true;
        ctrlPanel.subItems.find(x => x.menuItem == 'users').isVisible = true;
        ctrlPanel.subItems.find(x => x.menuItem == 'isVessel').isVisible = true;
      } else {
        ctrlPanel.subItems.find(x => x.menuItem == 'review').isVisible = false;
        ctrlPanel.subItems.find(x => x.menuItem == 'company').isVisible = false;
        ctrlPanel.subItems.find(x => x.menuItem == 'hazards-controls').isVisible = false;
        ctrlPanel.subItems.find(x => x.menuItem == 'threat-controls').isVisible = false;
      }
    } else {
      this.activeMenus.value.forEach(el => {
        if (el.id != 1) el.isVisible = false;
      })
    }


  }



}
